import { Box } from '@chakra-ui/react';
import React from 'react';

export const Footer = () => {
  return <Box h="3rem" backgroundColor="black" w="100%" />;
};
